export default "__VITE_ASSET__cdcc0091__"